import { useCurrentDatabaseManager } from "./useDatabases";
import { useEffect } from "react";

/**
 * Continuously sync changes from the remote to the local database, as long as `enabled` is true.
 */
export function useContinuousSync(inventoryId: string, enabled: boolean) {
  const manager = useCurrentDatabaseManager();

  useEffect(() => {
    if (manager && enabled) {
      const cancel = manager.syncDownContinuous(inventoryId);
      return () => cancel();
    }
  }, [inventoryId, manager, enabled]);
}
